import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import type { DocumentoDoExtratoInput } from "@bookdental/schemas";
import { trpc } from "@/lib/trpc";
import { campo, rotulo } from "@/components/financeiro/estilos";
import { PreviaDoExtrato } from "@/components/financeiro/config/PreviaDoExtrato";

const caixa = "h-4 w-4 accent-brand-600";

/** O documento do extrato — contatos, formas de pagamento e colunas. Mora no perfil do laboratório
 *  porque vale pro extrato simples dos Cadastros (grátis) e pro emitido do Financeiro (pago). */
export function DocumentoDoExtratoConfig({ podeEditar }: { podeEditar: boolean }) {
  const utils = trpc.useUtils();
  const dados = trpc.extratoSimples.documento.useQuery().data;
  const [form, setForm] = useState<DocumentoDoExtratoInput | null>(null);
  useEffect(() => {
    if (dados) setForm(dados.documento);
  }, [dados]);
  const salvar = trpc.extratoSimples.salvarDocumento.useMutation({
    onSuccess: () => {
      toast.success("Documento do extrato salvo.");
      utils.extratoSimples.invalidate();
      utils.financeiro.configExtrato.invalidate();
    },
    onError: (e) => toast.error(e.message),
  });
  if (!dados || !form) return null;
  const mudar = (parcial: Partial<DocumentoDoExtratoInput>) => setForm({ ...form, ...parcial });
  const texto = (k: "whatsapp" | "email" | "instagram") => ({ value: form[k] ?? "", onChange: (e: { target: { value: string } }) => mudar({ [k]: e.target.value }) });

  return (
    <div className="space-y-3">
      <div className="grid gap-6 lg:grid-cols-2">
        <fieldset disabled={!podeEditar} className="space-y-2">
          <label className="flex items-center gap-2 text-sm"><input type="checkbox" className={caixa} checked={form.mostrarDentista} onChange={(e) => mudar({ mostrarDentista: e.target.checked })} />Coluna de dentista</label>
          <label className="flex items-center gap-2 text-sm"><input type="checkbox" className={caixa} checked={form.mostrarDentes} onChange={(e) => mudar({ mostrarDentes: e.target.checked })} />Dentes de cada serviço</label>
          <label className="flex items-center gap-2 text-sm"><input type="checkbox" className={caixa} checked={form.mostrarRefacaoGratuita} onChange={(e) => mudar({ mostrarRefacaoGratuita: e.target.checked })} />Refação sem custo, com R$ 0,00</label>
          <div className="grid gap-3 pt-1 sm:grid-cols-3">
            <label><span className={rotulo}>WhatsApp</span><input {...texto("whatsapp")} placeholder="(11) 91234-5678" className={campo} /></label>
            <label><span className={rotulo}>E-mail (recebe as respostas)</span><input {...texto("email")} placeholder="contato@laboratorio.com" className={campo} /></label>
            <label><span className={rotulo}>Instagram</span><input {...texto("instagram")} placeholder="@laboratorio" className={campo} /></label>
          </div>
          <label className="block">
            <span className={rotulo}>Formas de pagamento</span>
            <textarea
              value={form.formasDePagamento ?? ""}
              onChange={(e) => mudar({ formasDePagamento: e.target.value })}
              rows={3}
              placeholder={"Transferência bancária: Banco, agência e conta\nPIX: chave"}
              className={`${campo} h-auto resize-none py-2`}
            />
          </label>
          {podeEditar && (
            <div className="flex justify-end">
              <button
                type="button"
                disabled={salvar.isPending}
                onClick={() => salvar.mutate(form)}
                className="inline-flex h-9 items-center gap-1.5 rounded-md bg-brand-600 px-4 text-sm font-semibold text-white shadow-sm hover:bg-brand-700 disabled:opacity-50"
              >
                {salvar.isPending && <Loader2 className="h-4 w-4 animate-spin" />}
                Salvar
              </button>
            </div>
          )}
        </fieldset>
        <PreviaDoExtrato laboratorio={dados.laboratorio} mostrarRefacaoGratuita={form.mostrarRefacaoGratuita} cabecalho={form} />
      </div>
    </div>
  );
}
